import createImmutableSelector from 'lib/immutable/selector'
import { IColaboraLayout } from './../models'

// TODO: import Store type and add reducer type in Store interface
const getColaboraLayout = (state: any): IColaboraLayout => state.get('colaboraLayoutReducer')

export const colaboraLayoutSelector = createImmutableSelector(getColaboraLayout, (colaboraLayout) => colaboraLayout)
